interface ArticleCTAProps {
  heading?: string
  cta?: string
}

export function ArticleCTA({
  heading = 'Start documenting your HSA expenses today',
  cta = 'Get Started Free',
}: ArticleCTAProps) {
  return (
    <div className="not-prose my-8 rounded-xl border border-[#C9A227] bg-[#fefce8] p-6 text-center">
      <p className="mb-3 font-bold text-[#1B365D]">{heading}</p>
      <a
        href="https://steadfasthsa.com"
        className="inline-block rounded-lg bg-[#1B365D] px-6 py-2 text-sm font-semibold text-white hover:bg-[#243b53] transition"
      >
        {cta}
      </a>
    </div>
  )
}
